// TODO: add prop types and default props and remove this linter bypass
/* eslint react/prop-types: 0 */
import React, { useContext } from 'react';
import { Button } from 'antd';

import {
  AttributesContext,
  BulkAddUsersAttributesContext,
  BulkAddUsersContext,
} from 'common/contexts';
import {
  BULK_ATTRIBUTE_NAME_IND,
  BULK_ATTRIBUTE_VALUE_IND,
  GENDER_ATTRIBUTE_NAME,
  PEER_CLASS_ATTRIBUTE_NAME,
  PHONE_ATTRIBUTE_NAME,
} from 'common/constants/constants';
import { SelectInput, TextInput } from './NewMemberFormInputs';

const genderSelectItemsFromAttributeTypes = attributeTypes =>
  attributeTypes
    ? attributeTypes
      .find(attributeType => attributeType.name === GENDER_ATTRIBUTE_NAME)
      .attributes.map(attribute => ({
        name: attribute.value,
        value: attribute.value,
      }))
    : [];
const peerClassSelectItemsFromAttributeTypes = attributeTypes =>
  attributeTypes
    ? attributeTypes
      .find(attributeType => attributeType.name === PEER_CLASS_ATTRIBUTE_NAME)
      .attributes.map(attribute => ({ name: attribute.value, value: attribute.value }))
    : [];

const NewMemberForm = ({ name, phone, ind, peerClass, gender, setAttribute, removeUser }) => {
  const { newMembers } = useContext(BulkAddUsersContext);
  const { bulkAttributes } = useContext(BulkAddUsersAttributesContext);
  const { attributes } = useContext(AttributesContext);
  const userInfo = attributes.genres.find(genre => genre.name === 'user-info');
  const attributeTypes = userInfo
    ? userInfo.sections.find(section => section.name === 'personal').attribute_types
    : null;
  const genderSelectItems = genderSelectItemsFromAttributeTypes(attributeTypes);
  const peerClassSelectItems = peerClassSelectItemsFromAttributeTypes(attributeTypes);
  const genderBulkAttribute = bulkAttributes.find(
    bulkAttribute => bulkAttribute[BULK_ATTRIBUTE_NAME_IND] === GENDER_ATTRIBUTE_NAME
  );
  const peerClassBulkAttribute = bulkAttributes.find(
    bulkAttribute => bulkAttribute[BULK_ATTRIBUTE_NAME_IND] === PEER_CLASS_ATTRIBUTE_NAME
  );

  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <TextInput
        onChange={event =>
          setAttribute({
            attributeType: 'name',
            attributeValue: event.target.value,
            ind,
          })}
        placeholder="Name"
        value={name}
        width="30vw"
      />
      <TextInput
        onChange={event =>
          setAttribute({
            attributeType: PHONE_ATTRIBUTE_NAME,
            attributeValue: event.target.value,
            ind,
          })}
        placeholder="Phone"
        value={phone}
        width="15vw"
      />
      <SelectInput
        disabled={!!genderBulkAttribute}
        dropdownItems={genderSelectItems}
        onChange={value =>
          setAttribute({
            attributeType: GENDER_ATTRIBUTE_NAME,
            attributeValue: value,
            ind,
          })}
        placeHolder={genderBulkAttribute ? genderBulkAttribute[BULK_ATTRIBUTE_VALUE_IND] : 'Gender'}
        value={gender}
        width="15vw"
      />
      <SelectInput
        disabled={!!peerClassBulkAttribute}
        dropdownItems={peerClassSelectItems}
        onChange={value =>
          setAttribute({
            attributeType: PEER_CLASS_ATTRIBUTE_NAME,
            attributeValue: value,
            ind,
          })}
        placeHolder={
          peerClassBulkAttribute ? peerClassBulkAttribute[BULK_ATTRIBUTE_VALUE_IND] : 'Peer Class'
        }
        value={peerClass}
        width="15vw"
      />
      {newMembers.length > 1 ? <Button onClick={() => removeUser(ind)}>remove</Button> : null}
    </div>
  );
};

export default NewMemberForm;
